'use client';

import Script from 'next/script';
import { usePathname } from 'next/navigation';
import { isPerformanceLabRoute } from './performanceLabNavRoutes';

const GOOGLE_ADS_ID = 'AW-614890616';
const PHONE_CONVERSION_ID = `${GOOGLE_ADS_ID}/obrZCPvL1MQcEPj4maUC`;
const PHONE_CONVERSION_NUMBER = '+918047282422';

/**
 * Google Ads conversion tags for Performance Lab pages.
 * Site-wide gtag bootstrap also lives in app/layout.tsx.
 */
export const PerformanceLabGoogleAdsHead = () => {
  const pathname = usePathname();

  if (!isPerformanceLabRoute(pathname)) {
    return null;
  }

  return (
    <>
      <Script
        strategy="afterInteractive"
        src={`https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`}
      />
      <Script
        id="performance-lab-google-ads-config"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${GOOGLE_ADS_ID}');
          `,
        }}
      />
      <Script
        id="performance-lab-google-ads-phone-conversion"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            gtag('config', '${PHONE_CONVERSION_ID}', {
              'phone_conversion_number': '${PHONE_CONVERSION_NUMBER}'
            });
          `,
        }}
      />
    </>
  );
};
